// extracted by mini-css-extract-plugin
export var title = "styles-module--title--1a6a7";
export var wrapper = "styles-module--wrapper--ae1b2";